import StickyEventListener from 'sticky-event-listener';

export default function () {
  if (document.querySelector('.pricing-features-box')) {

    document
      .querySelectorAll('.pricing-features-row.block-headline')
      .forEach(sticker => {
        new StickyEventListener(sticker);
        sticker.addEventListener('sticky', event => {
          if (event.detail.stuck) {
            sticker.classList.add('stuck');
          } else {
            sticker.classList.remove('stuck');
          }
        });
      });

    document.documentElement.style.setProperty('--scrollbar-width', (window.innerWidth - document.documentElement.clientWidth) + 'px');

    document.querySelectorAll('.pricing-features-cell-style-block-headline-row').forEach(function(block) {
      block.addEventListener('click', function() {
        let $identifier = this.getAttribute('data-block');
        document.querySelectorAll('[data-block="' + $identifier + '"]:not(.pricing-features-cell-style-block-headline-row)').forEach(function(element) {
          element.classList.toggle('hide-xs');
          element.classList.toggle('hide-sm');
          element.classList.toggle('hide-md');
        });
        document.querySelectorAll('[data-block="' + $identifier + '"].pricing-features-cell-style-block-headline').forEach(function(headline) {
          headline.classList.toggle('block-hidden');
        });
      });
    });
  }
}
